module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('hrms-staappr', {
    attrs: {
      "staappr": _vm.detail.staappr,
      "nowLang": _vm.nowLang,
      "currentDtereq": _vm.setDateOutput(_vm.currentDtereq),
      "currentNumseq": _vm.currentNumseq,
      "currentCodempid": _vm.currentCodempid
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box-func"
  }, [_c('div', {
    staticClass: "box-topic border-color-skin"
  }, [_c('i', {
    staticClass: "fa fa-envelope margin-r-5 color-skin"
  }), _vm._v(" "), _c('label', {
    staticClass: "color-skin"
  }, [_vm._v(_vm._s(_vm.descCodapp))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('form', {
    attrs: {
      "role": "form"
    }
  }, [_c('div', {
    staticClass: "col-lg-1"
  }), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['20']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6 col-ms-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['30']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|before:dteend'),
      expression: "'required|date_format:DD/MM/YYYY|before:dteend'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputDate",
      "name": "dtestrt",
      "has-error": _vm.errors.has('dtestrt')
    },
    model: {
      value: (_vm.detail.dtestrt),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dtestrt", $$v)
      },
      expression: "detail.dtestrt"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dtestrt')),
      expression: "errors.has('dtestrt')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dtestrt')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-ms-6 col-sm-6"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['40']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-datepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|date_format:DD/MM/YYYY|after:dtestrt'),
      expression: "'required|date_format:DD/MM/YYYY|after:dtestrt'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputDate",
      "name": "dteend",
      "has-error": _vm.errors.has('dteend')
    },
    model: {
      value: (_vm.detail.dteend),
      callback: function($$v) {
        _vm.$set(_vm.detail, "dteend", $$v)
      },
      expression: "detail.dteend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('dteend')),
      expression: "errors.has('dteend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('dteend')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('h4', {
    staticClass: "page-header"
  }, [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['50']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['60']))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbend|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbend|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputTime",
      "name": "timbstr",
      "has-error": _vm.errors.has('timbstr')
    },
    model: {
      value: (_vm.detail.timbstr),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timbstr", $$v)
      },
      expression: "detail.timbstr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timbstr')),
      expression: "errors.has('timbstr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timbstr')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbstr|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timbstr|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputTime",
      "name": "timbend",
      "has-error": _vm.errors.has('timbend')
    },
    model: {
      value: (_vm.detail.timbend),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timbend", $$v)
      },
      expression: "detail.timbend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timbend')),
      expression: "errors.has('timbend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timbend')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['70']))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdend|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdend|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputTime",
      "name": "timdstr",
      "has-error": _vm.errors.has('timdstr')
    },
    model: {
      value: (_vm.detail.timdstr),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timdstr", $$v)
      },
      expression: "detail.timdstr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timdstr')),
      expression: "errors.has('timdstr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timdstr')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdstr|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timdstr|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputTime",
      "name": "timdend",
      "has-error": _vm.errors.has('timdend')
    },
    model: {
      value: (_vm.detail.timdend),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timdend", $$v)
      },
      expression: "detail.timdend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timdend')),
      expression: "errors.has('timdend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timdend')))])], 1)])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['80']))]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timaend|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timaend|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputTime",
      "name": "timastr",
      "has-error": _vm.errors.has('timastr')
    },
    model: {
      value: (_vm.detail.timastr),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timastr", $$v)
      },
      expression: "detail.timastr"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timastr')),
      expression: "errors.has('timastr')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timastr')))])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6"
  }, [_c('label', [_vm._v(" ")]), _vm._v(" "), _c('span', {
    staticClass: "pull-left",
    staticStyle: {
      "margin-top": "30px",
      "margin-left": "-15px"
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('hrms-timepicker', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timastr|date_format:HH:mm'),
      expression: "'requiredAny:timbstr,timbend,timdstr,timdend,timastr,timaend|requiredWhenExist:timastr|date_format:HH:mm'"
    }],
    attrs: {
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputTime",
      "name": "timaend",
      "has-error": _vm.errors.has('timaend')
    },
    model: {
      value: (_vm.detail.timaend),
      callback: function($$v) {
        _vm.$set(_vm.detail, "timaend", $$v)
      },
      expression: "detail.timaend"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('timaend')),
      expression: "errors.has('timaend')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('timaend')))])], 1)])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-md-6 col-lg-5"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 panel-codrem"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['90']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('hrms-dropdown', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    attrs: {
      "options": _vm.arrCodrem[_vm.nowLang],
      "disabled": !_vm.validateStaappr,
      "data-vv-value-path": "inputValue",
      "data-vv-name": "codrem",
      "has-error": _vm.errors.has('codrem')
    },
    model: {
      value: (_vm.detail.codrem),
      callback: function($$v) {
        _vm.$set(_vm.detail, "codrem", $$v)
      },
      expression: "detail.codrem"
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('codrem')),
      expression: "errors.has('codrem')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('codrem')))])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 panel-remark"
  }, [_c('div', {
    staticClass: "form-group clearfix"
  }, [_c('label', [_vm._v(_vm._s(_vm.labels['HRES6KEC2']['95']) + " "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required|max:200'),
      expression: "'required|max:200'"
    }, {
      name: "model",
      rawName: "v-model",
      value: (_vm.detail.remark),
      expression: "detail.remark"
    }],
    class: {
      'form-control': true, 'input-error': _vm.errors.has('remark')
    },
    attrs: {
      "name": "remark",
      "maxlength": "200",
      "disabled": !_vm.validateStaappr
    },
    domProps: {
      "value": (_vm.detail.remark)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.detail, "remark", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('remark')),
      expression: "errors.has('remark')"
    }],
    staticClass: "text-error"
  }, [_vm._v(_vm._s(_vm.errors.first('remark')))]), _vm._v(" "), _c('div', {
    staticClass: "remark-limit-character"
  }, [_vm._v(_vm._s(_vm.dispLimitLabel(200)))])])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "box-footer"
  }, [_c('button', {
    staticClass: "btn bg-dark-gray",
    attrs: {
      "type": "button",
      "value": "Back"
    },
    on: {
      "click": function($event) {
        _vm.callBack()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-chevron-circle-left"
  }), _vm._v(_vm._s(_vm.labelsButton['back']))]), _vm._v(" "), (_vm.validateStaappr) ? _c('button', {
    staticClass: "btn bg-color-skin",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.callSave()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check-circle"
  }), _vm._v(_vm._s(_vm.labelsButton['save']))]) : _vm._e()])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-52ba5d5f!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/hres6ke/detail.vue
// module id = 3758
// module chunks = 1